import axios from 'axios';
import { z } from 'zod';

export function replaceSpecialChar(str: string): string {
    if (str) {
        return str
            .toString()
            .trim()
            .replace(/[\\/:*"<>|?]/g, '_');
    }
    return '_';
}

export function addHypen(phoneNumber: string): string {
    if (phoneNumber) {
        return phoneNumber.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
    }
    return '';
}

export function getToday(): string {
    const today = new Date();
    const dd = String(today.getDate()).padStart(2, '0');
    const mm = String(today.getMonth() + 1).padStart(2, '0');
    const yyyy = today.getFullYear();

    const result = yyyy + mm + dd;

    return result;
}

export const getErrorMessage = (err: any): string => {
    console.log(err);
    let errorMsg = '';
    // Sentry.withScope(scope => {
    if (typeof err === 'string') {
        console.log(1);
        // scope.setFingerprint([err]);
        // Sentry.captureMessage(err, { level });
        errorMsg = err;
    } else if (err instanceof z.ZodError) {
        errorMsg = err.issues[0].message;
    } else {
        // let fingerprint: string[] = [];
        if (axios.isAxiosError(err)) {
            console.log(2);
            // const { method, url } = err.config;
            // const { status } = err.response;
            errorMsg = err?.response?.data?.message;
            // fingerprint = [method, `${status}`, url, JSON.stringify(err)];
        } else if (err?.message) {
            console.log(3);
            errorMsg = err.message;
            // fingerprint = [`${err.message}`];
        }
        // scope.setFingerprint(fingerprint);
        // Sentry.captureException(new ApiError(err, errorMsg, sentryErrorName), { level });
    }
    // });
    console.log(errorMsg);
    return errorMsg ?? '알 수 없는 에러';
};
